import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLogIn = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 12 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.19733 0.494243C6.43533 0.215576 7.33333 1.27958 7.33333 2.33158V11.6649C7.33333 12.7169 6.43533 13.7809 5.19733 13.5022C2.22267 12.8329 0 10.1756 0 6.99824C0 3.82091 2.22267 1.16358 5.19733 0.494243ZM8.862 4.52691C8.98702 4.40193 9.15656 4.33172 9.33333 4.33172C9.51011 4.33172 9.67965 4.40193 9.80467 4.52691L11.8047 6.52691C11.9296 6.65193 11.9999 6.82147 11.9999 6.99824C11.9999 7.17502 11.9296 7.34456 11.8047 7.46958L9.80467 9.46958C9.67893 9.59102 9.51053 9.65821 9.33573 9.65669C9.16094 9.65517 8.99373 9.58506 8.87012 9.46146C8.74652 9.33785 8.6764 9.17064 8.67488 8.99584C8.67336 8.82105 8.74056 8.65265 8.862 8.52691L9.724 7.66491H4C3.82319 7.66491 3.65362 7.59467 3.5286 7.46965C3.40357 7.34462 3.33333 7.17505 3.33333 6.99824C3.33333 6.82143 3.40357 6.65186 3.5286 6.52684C3.65362 6.40181 3.82319 6.33158 4 6.33158H9.724L8.862 5.46958C8.73702 5.34456 8.66681 5.17502 8.66681 4.99824C8.66681 4.82147 8.73702 4.65193 8.862 4.52691Z",
		fill: "currentColor"
	})
});
export default SvgLogIn;
